import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, MaskLine } from "@/components/site/Reveal";

const STATEMENT = "We play it loud everywhere except the scene. No fumes. No pull cords. No waiting on an engine. Just squeeze, cut, and get your people out.".split(" ");

function Word({ word, i, progress }) {
  const start = i / STATEMENT.length;
  const opacity = useTransform(progress, [start * 0.8, start * 0.8 + 0.12], [0.18, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{word}</motion.span>;
}

export function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 40%"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="manifesto-section" className="grain relative overflow-hidden bg-obsidian py-24 md:py-36">
      <div className="mx-auto grid max-w-[1500px] gap-12 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Eyebrow>The BAMF Way</Eyebrow>
          <h2 className="mt-5 font-display text-[12.5vw] sm:text-6xl md:text-8xl font-black uppercase leading-[0.85]" style={{ fontWeight: 900 }}>
            <MaskLine inView>Loud</MaskLine>
            <MaskLine inView delay={0.1}><span className="text-outline">attitude.</span></MaskLine>
            <MaskLine inView delay={0.2}><span className="text-volt">Quiet</span> saw.</MaskLine>
          </h2>
          <p data-testid="manifesto-statement" className="mt-10 max-w-2xl font-display text-3xl md:text-5xl font-bold uppercase leading-[1.05]">
            {STATEMENT.map((w, i) => <Word key={i} word={w} i={i} progress={scrollYProgress} />)}
          </p>
          <div className="mt-10 flex items-center gap-4">
            <div className="h-[3px] w-16 bg-rescue" />
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-300">Built for the ones who run toward it</p>
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="clip-notch relative aspect-[3/4] overflow-hidden">
            <motion.img style={{ y: imgY, scale: 1.18 }} src="/img/extrication.webp" alt="Firefighter performing vehicle extrication with a BAMF saw" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            <img src="/img/logo-a.webp" alt="BAMF Rescue Saws logo" className="absolute bottom-4 right-4 w-32 md:w-40" />
          </div>
        </div>
      </div>
    </section>
  );
}
